module.exports = __webpack_public_path__ + "img/a64.21660c46.png";